import { useQuery } from '@tanstack/react-query'
import type { ProcessesApiFindLineItemsRequest } from '@itsrever/dashboard-api'
import { getLineItems } from '@/api/processes-api'

export const useItems = (filters: ProcessesApiFindLineItemsRequest) => {
  return useQuery({
    queryKey: [
      'items',
      filters.ecommerceId,
      filters.limit,
      filters.offset,
      filters.freetext,
      filters.startedAtGte,
      filters.startedAtLte,
      filters.lastKnownShippingStatus,
      filters.lineItemReturnReason,
      filters.lineItemsReviewsStatus,
      filters.returnStatus,
      filters.reviewAvailable
    ],
    queryFn: async () => {
      const response = await getLineItems(filters)

      return response
    },
    placeholderData: (prev) => prev
  })
}
